module.exports = __webpack_public_path__ + "static/media/rightArrowBlackIcon.19db368c.svg";